import TestComponent from '@/components/TestComponent'
import { ActionFunction, defer, LoaderFunction } from 'react-router-typesafe'
import { json } from 'react-router-dom'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { RoleRouteObject } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { notifica } from '@/model/qsadminapi/QsAdminApiModuleModel'

export const TestComponentLoader = (async () => {
  const qsAdminApi = useQsAdminApiManager.getState().service
  const hour = qsAdminApi.attivita_lavorativa(223806).query((builder) => {
    builder.expand('impiegato', 'task', 'causale', 'centro_costo', 'intervento', 'piattaforma', 'sede')
  })
  return {
    hour: (await hour).data,
  }
}) satisfies LoaderFunction

export const TestComponentAction = (async ({ request }) => {
  try {
    // Get form data
    const formData = await request.formData()

    // Prepare notification data in the correct format
    // Create a proper notifica object that matches the backend model
    const notificaData = {
      id: 0, // Will be assigned by the server
      contenuto: formData.get('contenuto') as string,
      data: formData.get('data') as string,
      gestita: formData.get('gestita') === 'true',
      tipologia: {
        id: Number(formData.get('tipologia')),
      },
      // Only include user if userId is provided
      ...(formData.has('userId') && formData.get('userId') !== ''
        ? { user: { id: Number(formData.get('userId')) } }
        : {}),
    }

    // Log the data we're sending to the API
    console.log('Sending notification data to API:', notificaData)

    // Send to API
    const qsAdminApi = useQsAdminApiManager.getState().service
    const result = await qsAdminApi.notifica().create(notificaData)

    // Return success response
    return json({ success: true, result })
  } catch (error) {
    console.error('Error creating notification:', error)
    return json({ success: false, error: String(error) }, { status: 400 })
  }
}) satisfies ActionFunction

export const TestRoute = {
  path: 'test',
  loader: TestComponentLoader,
  action: TestComponentAction,
  element: <TestComponent />,
  allowedRoles: [Roles.Guest],
} satisfies RoleRouteObject
